export default {
  getAvailableDaysForSelect: state => state.days.map(day => ({
    value: day.id,
    label: day.name,
  })),
};
